// @core/api/endpoints/workflow/update_credential.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CredentialResponse,
  UpdateCredentialRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Update credential
 * Updates credential metadata (name, description). To update secret values, use SecretService directly.
 */
export async function UpdateCredential(
  credential_id: string,
  data: UpdateCredentialRequest,
  options?: RequestOptions
): Promise<CredentialResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/credentials/:credential_id`;
  requestPath = requestPath.replace(':credential_id', encodeURIComponent(credential_id));
  const requestOptions = options;
  return client.put<CredentialResponse>(requestPath, data, requestOptions);
}
